import { Group } from '@mantine/core';
import { IconHierarchy } from '@tabler/icons-react';
import { OrganizationRow } from 'components/tables/data/organization/types';
import P2Regular from 'components/typography/P2Regular';

/** Column for the effective hierarchy used by an organization. */
export default function HierarchyColumn({ data: { hierarchyName } }: { data: OrganizationRow }) {
  return (
    <Group spacing={8} noWrap>
      <IconHierarchy stroke="1.5" height={24} width={24} />
      <P2Regular color="gray.8">{hierarchyName}</P2Regular>
    </Group>
  );
}
